import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { baseAdministrationActions, baseAdministrationSelectors, BaseCoreState } from '../../../_store';

@Injectable({ providedIn: 'root' })
export class BasePermissionsGuard {
  constructor(private store: Store<BaseCoreState>) {}

  canActivate(): Observable<boolean> {
    this.store.dispatch(baseAdministrationActions.loadPermissions());

    return this.store.select(baseAdministrationSelectors.getPermissions).pipe(
      filter((state) => state?.ok !== undefined),
      map((state) => state?.ok as boolean)
    );
  }
}
